<template>
  <div class="seat-container">
    <div
      :id="seat.id"
      :class="cssClass"
      :style="style"
      class="seat"
      :data-rowname="seat.rowName"
      :data-seatname="seat.seatName"
      :data-seattext="seat.seatText"
      @mouseover="displayTooltip"
      @mouseleave="displayToolTip = false"
      @click="seatClick"
    >
      <span>{{ seat.rowName }}{{ seat.seatName }}</span>
    </div>
    <div v-show="displayToolTip" :style="tooltipStyle" class="seat-info">
      <span>{{ description }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    seat: { type: [Object], default: null },
    seatHeight: { type: Number, default: null },
    seatWidth: { type: Number, default: null },
    prices: { type: [Object], default: null },
    basketItems: { type: Array, default: null }
  },
  data() {
    return {
      displayToolTip: false,
      toolTipX: 0,
      toolTipY: 0
    };
  },
  computed: {
    disabled() {
      return !this.basketItems || this.basketItems.length == 0;
    },
    cssClass() {
      return (
        (this.prices.priceBands.find(x => x.id === this.seat.priceBandId)
          .cssClass || '') +
        (this.isActive(this.seat.id) || '') +
        ' ' +
        (this.seat.status || '')
      );
    },
    style() {
      return (
        'background-color:#' +
        this.prices.priceBands.find(x => x.id === this.seat.priceBandId)
          .backgroundColor +
        ';color:' +
        this.prices.priceBands.find(x => x.id === this.seat.priceBandId).color +
        ';left:' +
        this.seat.xpos +
        'px; top: ' +
        this.seat.ypos +
        'px; width: ' +
        this.seatWidth +
        'px; height: ' +
        this.seatHeight +
        'px; transform: rotate(' +
        this.seat.rotation +
        'deg);'
      );
    },
    tooltipStyle() {
      return 'top:' + this.toolTipY + 'px; left:' + this.toolTipX + 'px';
    },
    description() {
      return (
        this.seat.rowName +
        this.seat.seatName +
        ' ' +
        this.prices.priceBands.find(x => x.id === this.seat.priceBandId)
          .description +
        ' ' +
        this.priceRange(this.seat.priceBandId)
      );
    }
  },
  methods: {
    isActive(itemId) {
      if (this.disabled) {
        return ' disabled';
      }
      if (this.basketItems && this.basketItems.find(x => x.id === itemId)) {
        return ' itemheld';
      }
    },
    priceRange(priceBandId) {
      var prices = [];
      Object.values(this.prices.prices).forEach(function(concessionPrice) {
        prices.push(concessionPrice[priceBandId]);
      });
      if (prices.length == 1) {
        return '£' + prices[0].toFixed(2);
      } else {
        return (
          '£' +
          Math.min(...prices).toFixed(2) +
          ' - £' +
          Math.max(...prices).toFixed(2)
        );
      }
    },
    displayTooltip(event) {
      if (this.seat.status == 'itemavailable' && !this.disabled) {
        this.toolTipY = event.pageY - window.pageYOffset + 10;
        this.toolTipX = event.pageX - window.pageXOffset + 10;
        this.displayToolTip = true;
      }
    },
    seatClick() {
      if (!this.disabled) {
        this.$emit('seat-click', this.seat.id);
      }
    }
  }
};
</script>
